import Image from './Image'

class Project {
    private name: string;
    private description: string;
    private url: string;
    private image: Image[];
    private technologies: string[];

    constructor(image: Image[], name: string, description: string, technologies: string[], url?: string) {
        this.image = image;
        this.name = name;
        this.description = description;
        this.technologies = technologies;
        this.url = url || "";
    }

    getImage() {
        return this.image;
    }

    getName() {
        return this.name;
    }

    getDescription() {
        return this.description;
    }

    getTechnologies() {
        return this.technologies;
    }

    getUrl() {
        return this.url;
    }
}

export default Project